import clipboard from "./clipboard";
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import historyReducer from "./history";
import pagedata from "./pagedata";
import settings from "./settings";
import typeahead from "./typeahead";

const createRootReducer = (history) =>
  combineReducers({
    clipboard,
    history: historyReducer,
    pagedata,
    router: connectRouter(history),
    settings,
    typeahead,
  });

export default createRootReducer;
